import { SqliteJsonRepository } from './SqliteJsonRepository';
import type { Ecriture } from '@shared/types/Ecriture';

export class SqliteEcritureRepository extends SqliteJsonRepository<Ecriture> {
  constructor() {
    super('ecritures');
  }
}
